module.exports = __webpack_public_path__ + "img/杭州星光.aecd830e.png";